import { CellComp } from './Cell';
import { ColComp, ColsComp } from './Cols';
import { RowComp, RowsComp } from './Rows';
import { TableComp, TableWrapperComp } from './Table';



export default {
  Row: RowComp,
  Rows: RowsComp,
  Col: ColComp,
  Cols: ColsComp,
  Table: TableComp,
  TableWrapper: TableWrapperComp,
  Cell: CellComp,
};
